import "../styles/TaskWindow.css";
import "./styles/DominoApp.css";
import "./styles/GameSpace.css";
import "./styles/InformationSpace.css";
import { DominoesStore } from "../../Stores/DominoesStore";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import paws_image from "../../img/Mini-games/Domino/paws.svg";
import gearWheel_image from "../../img/Mini-games/Domino/gearWheels.svg";
import puzzle_image from "../../img/Mini-games/Domino/puzzle.svg";
import kotobot_image from "../../img/Mini-games/Domino/kotobot.jpeg";
import chipus_image from "../../img/Mini-games/Domino/chipus.jpg";
import logicus_image from "../../img/Mini-games/Domino/logicus.jpg";
import logicus_logo from "../../img/Mini-games/Domino/logicus.png";
import kotobot_svg from "../../img/Mini-games/Domino/kotobot.svg";
import { InsideDomino } from "./InsideDomino";
import { ModalWindow } from "./ModalWindow";
import { DominoButton } from "../../Components/StyledComponents/DominoButton";
import { Content } from "../../Components/Content";
import { BackgroundEnum } from "../../Enums/ThemeEnums";

export interface IModalCondition {
  isOpen: boolean;
}

interface DominoProps {
  words: string[];
}

export const DominoApp = observer((props: DominoProps) => {
  const kotobotName = "Котобот";
  const logicusName = "Логикус";
  const chipusName = "Чипус";

  const [showHelpModalWindow, setShowHelpModalWindow] = useState(false);
  const [imageConnectElem, setImageConnectElem] = useState(puzzle_image);
  const [imageCharacter, setImageCharacter] = useState(logicus_image);
  const [logoCharacter, setLogoCharacter] = useState(logicus_logo);
  const [characterName, setCharacterName] = useState(logicusName);
  const [dominoesStore, setDominoesStore] = useState(new DominoesStore(props.words));

  /** Moving domino to free place*/
  const movingDominoToFreePlace = (dominoId: number): void => {
    dominoesStore.moveDominoToSlot(dominoId);
  };

  /** Moving domino to home */
  const movingDominoToHome = (slotId: number): void => {
    try {
      if (dominoesStore.getSlotById(slotId).isCorrect === false)
        dominoesStore.moveDominoToHome(slotId);
    } catch (error) {
      alert(error);
    }
  };

  /** Checking whether the domino is not correct */
  const isWrongly = (): boolean => {
    for (let i: number = 0; i < dominoesStore.slots.length; i += 1) {
      if (
        dominoesStore.slots[i].isFree === false &&
        dominoesStore.slots[i].isCorrect === false
      )
        return true;
    }
    return false;
  };

  /** Checking whether the game is over */
  const checkEndingGame = () => {
    if (dominoesStore.dominoes.length === 0) {
      return true;
    }
    return false;
  };

  return (
    <Content
      width="100%"
      height="100vh"
      withTopWave={false}
      withBottomWave={false}
      bg={BackgroundEnum.grey}
    >
      <div className="domino-content">
      <div className="domino-app main-panel">
        <div className="information-space">
          <img
            className="kotobot-svg"
            src={kotobot_svg}
            title="На главную страницу"
            width="1400"
          ></img>

          <img className="character" src={imageCharacter}></img>
          <img className="character-name" src={logoCharacter}></img>

          {/*<button onClick={()=>{
            setImageConnectElem(paws_image)
            setImageCharacter(kotobot_image)
            setCharacterName(kotobotName)}}>
            Котобот
          </button>
          <button onClick={()=>{
            setImageConnectElem(gearWheel_image)
            setImageCharacter(chipus_image)
            setCharacterName(chipusName)}}>
              Чипус
          </button>
          <button onClick={()=>{
            setImageConnectElem(puzzle_image)
            setImageCharacter(logicus_image)
            setCharacterName(logicusName)}}>
              Логикус
          </button>*/}

          {/*Opening a modal window*/}
          <button
            className="play-rules"
            onClick={() => setShowHelpModalWindow(true)}
          >
            Правила игры
          </button>
        </div>

        <div className="game-space">
          <h1>Собери цепочку из слов</h1>
          <div className="domino-zone save-domino">
            {dominoesStore.slots.map((slot) => (
              <div key={slot.id}>
                {/* free places*/}
                <DominoButton
                  isFree={slot.isFree}
                  onClick={() => movingDominoToHome(slot.id)}
                  disabled={slot.isFree}
                  isOnFreePlace={false}
                >
                  <InsideDomino
                    content={slot}
                    isFree={slot.isFree}
                  ></InsideDomino>
                </DominoButton>

                {/*Checking domino : if is right domino*/}

                {slot.isFree === false &&
                slot.isCorrect === true &&
                slot.id !== 1 ? (
                  <img
                    className={
                      imageConnectElem === puzzle_image
                        ? "connect-elem"
                        : "connect-elem" + " connect-elem-rotate"
                    }
                    src={imageConnectElem}
                  ></img>
                ) : slot.isFree === true ? (
                  ""
                ) : slot.id === 1 ? (
                  ""
                ) : (
                  <span className="text-is-not-right">Неверно</span>
                )}
              </div>
            ))}
          </div>
          <div className="domino-zone house-of-domino">
            {dominoesStore.dominoes.map((domino) => (
              <div key={domino.id}>
                {/*dominoes */}
                <DominoButton
                  onClick={() => movingDominoToFreePlace(domino.id)}
                  disabled={isWrongly()}
                  isOnFreePlace
                >
                  <InsideDomino content={domino}></InsideDomino>
                </DominoButton>
              </div>
            ))}
            {checkEndingGame() ? (
              <span className="text-ending-game">Игра завершена! Молодец!</span>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      </div>

      {showHelpModalWindow && (
        <ModalWindow
          dominoesStore={dominoesStore}
          imageConnectElem={imageConnectElem}
          onModalClose={() => setShowHelpModalWindow(false)}
        />
      )}
    </Content>
  );
});
